import numeral from "numeral";
numeral.locale("es");
export default function downloadHtml(data, columns, headings, filename) {
  // Table init
  let csv = "<table>";
  // Row of columns
  csv += "<tr>";
  columns.forEach((column) => (csv += `<th>${headings[column]}</th>`));
  csv += "</tr>";

  // Rows of details
  for (let item in data) {
    csv += "<tr>";
    columns.forEach((column) => {
      let color = "";
      // const bootstrap_color = data[item]["last_inspection"]["color"];
      // color =
      //   bootstrap_color == "primary"
      //     ? "style='color: #20a8d8'"
      //     : bootstrap_color == "secondary"
      //     ? "style='color: #c8ced3'"
      //     : bootstrap_color == "success"
      //     ? "style='color: #4dbd74'"
      //     : bootstrap_color == "warning"
      //     ? "style='color: #ffc107'"
      //     : bootstrap_color == "danger"
      //     ? "style='color: #f86c6b'"
      //     : "";
      if (column == "last_inspection") {
        csv += `<td ${color}>${data[item]["last_inspection"]["name"]}</td>`;
      } else if (column.includes(".")) {
        const nested = column.split(".");
        csv += `<td ${color}>${data[item][nested[0]][nested[1]] ? data[item][nested[0]][nested[1]] : ""}</td>`;
      } else if (column == "net_kilograms") {
        csv += `<td>${numeral(parseFloat(data[item][column])).format("0.00")}</td>`;
      } else {
        csv += `<td ${color}>${data[item][column] ? data[item][column] : ""}</td>`;
      }
    });
    csv += "</tr>";
    csv += "<style>";
    csv += ".text-danger {color: #f86c6b !important;}";

    csv += "</style>";
  }

  // Table end
  csv += "</table>";
  const date = new Date();
  const anchor = document.createElement("a");
  anchor.href = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(csv);
  anchor.target = "_blank";
  anchor.download = `${filename} ${date.toLocaleString()}.xls`;
  anchor.click();
}
